import { IBorcAlacak } from "./finance.model";

export interface IDigerBorcAlacak extends IBorcAlacak {
    digerBorcID: number;
}

export class DigerBorcAlacakFilter {
    digerBorcAlacak: string;
    durum: boolean;
}